/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit NoMenu.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromFlow from 'Logic/ViewsFlow.js'
import MenuIcon from 'DesignSystem/Svgs/MenuIcon/view.js'
import React from 'react'
import useIsHovered from 'Logic/useIsHovered.js'
import { css } from "emotion"

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
borderBottomLeftRadius: 5,
borderBottomRightRadius: 5,
borderTopLeftRadius: 5,
borderTopRightRadius: 5,
marginLeft: 30,
paddingLeft: 8,
paddingRight: 8,
paddingTop: 8,
paddingBottom: 8,
userSelect: "none",
  
transition: 'background-color 150ms linear',
willChange: 'background-color',
  backgroundColor: 'var(--backgroundColor)'})

export default function NoMenu({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Menu/NoMenu"
}) {
    
    let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
    
    let setFlowTo = fromFlow.useSetFlowTo(viewPath)
    
    

  return (<React.Fragment
>
<button
 data-testid="NoMenu.Horizontal"
 data-view-path="/App/MyAccount/Menu/NoMenu"
 onClick={() => setFlowTo("/App/MyAccount/Menu/Expanded")}
 {...isHoveredBind}
 style={{'--backgroundColor': isHovered ? "#f2f2f2" : "transparent"}}
 className={`views-block ${styles.Horizontal}`}
>
<MenuIcon
 data-testid="NoMenu.MenuIcon"
 data-view-path="/App/MyAccount/Menu/NoMenu"
viewPath={`${viewPath}/MenuIcon`}
 width={20}
 height={20}
 stroke="#303030"
/>
</button>
{children}
</React.Fragment>)
}